<gtw-confirmation-modal
  [config]="modalConfig"
  [visible]="false"
  (confirmed)="confirm_save()"
  (cancelled)="cancel()"
  (closed)="cancel()">
</gtw-confirmation-modal>
